import React from 'react';

import css from '../Tabs.module.scss';

const TabAbout = ({ description }) => {
  return <p className={css['Tabs-about-text']}>{description}</p>;
};

export default TabAbout;
